module.exports = "<div class=\"scope-content-continer\">\n    <div class=\"scope-content-continer-item\" >\n        <h4>Schema</h4>\n        <p>\n            {{item.name}}\n        </p>\n    </div>\n    <div class=\"scope-content-continer-item\">\n        <h4>Server Name</h4>\n        <p>\n            {{item.hostName}}\n        </p>\n </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/project/impact-analysis/impact-analysis-scopes-ang7/impact-analysis-scope/impact-analysis-scope.html
// module id = 1783
// module chunks = 0